import { useState } from "react";
import {
  DAYS, FULL_DAYS, PERIOD_ICONS,
  formatTime12, DaySelector, CopyMenu, TimeSelect,
} from "./shared";

function PeriodToggle({ name, active, start, end, onToggle, onStart, onEnd, isMobile }) {
  return (
    <div style={{ padding: isMobile ? "12px 14px" : "12px 16px", borderRadius: 12, background: active ? "#FAFAFA" : "#FDFDFD", border: active ? "1px solid #E5E5E5" : "1px solid #F0F0F0", opacity: active ? 1 : 0.5, transition: "all 0.2s ease" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: active ? 12 : 0 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: 18 }}>{PERIOD_ICONS[name]}</span>
          <span style={{ fontSize: isMobile ? 15 : 14, fontWeight: 600, color: active ? "#1a1a1a" : "#999", fontFamily: "'DM Sans',sans-serif" }}>{name}</span>
        </div>
        <button onClick={onToggle} style={{ width: 44, height: 26, borderRadius: 13, border: "none", background: active ? "#2D8F5E" : "#DDD", cursor: "pointer", position: "relative", transition: "background 0.2s ease", WebkitTapHighlightColor: "transparent" }}>
          <div style={{ width: 20, height: 20, borderRadius: "50%", background: "#FFF", position: "absolute", top: 3, left: active ? 21 : 3, transition: "left 0.2s cubic-bezier(0.4,0,0.2,1)", boxShadow: "0 1px 3px rgba(0,0,0,0.15)" }} />
        </button>
      </div>
      {active && <div style={{ display: "flex", gap: 12 }}><TimeSelect value={start} onChange={onStart} isMobile={isMobile} label="Start" /><TimeSelect value={end} onChange={onEnd} isMobile={isMobile} label="End" /></div>}
    </div>
  );
}

export default function Step2Hours({ data, setData, isMobile }) {
  const [sel, setSel] = useState(0);
  const [cardKey, setCardKey] = useState(0);
  const [showCopy, setShowCopy] = useState(false);
  const dd = data.dayData;

  const setField = (di, f, v) => {
    const u = [...dd];
    u[di] = { ...u[di], [f]: v };
    setData(p => ({ ...p, dayData: u }));
  };

  const setPeriod = (di, pn, f, v) => {
    const u = [...dd];
    u[di] = { ...u[di], periods: { ...u[di].periods, [pn]: { ...u[di].periods[pn], [f]: v } } };
    setData(p => ({ ...p, dayData: u }));
  };

  const copyDay = (targets) => {
    const u = [...dd];
    const src = dd[sel];
    targets.forEach(di => { if (di !== sel) u[di] = JSON.parse(JSON.stringify(src)); });
    setData(p => ({ ...p, dayData: u }));
  };

  const d = dd[sel];

  return (
    <div style={{ maxWidth: 1000, margin: "0 auto" }}>
      <div style={{ marginBottom: isMobile ? 20 : 28, textAlign: "center" }}>
        <h1 style={{ fontSize: isMobile ? 22 : 28, fontWeight: 700, color: "#1a1a1a", margin: "0 0 4px", fontFamily: "'DM Sans',sans-serif", letterSpacing: "-0.02em" }}>Hours & Meal Periods</h1>
        <p style={{ fontSize: isMobile ? 13 : 15, color: "#888", margin: 0 }}>Set when you're open and which meals you serve each day</p>
      </div>

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10, padding: "0 4px" }}>
        <h3 style={{ fontSize: 15, fontWeight: 600, color: "#1a1a1a", margin: 0, fontFamily: "'DM Sans',sans-serif" }}>
          {FULL_DAYS[sel]}
          {d.isOpen && <span style={{ fontSize: 13, fontWeight: 400, color: "#999", marginLeft: 8 }}>{formatTime12(d.open)} – {formatTime12(d.close)}</span>}
          {!d.isOpen && <span style={{ fontSize: 13, fontWeight: 500, color: "#E85D3A", marginLeft: 8 }}>Closed</span>}
        </h3>
        <CopyMenu label={DAYS[sel]} onCopy={copyDay} show={showCopy} setShow={setShowCopy} isMobile={isMobile} dayData={dd} selectedDay={sel} />
      </div>

      <DaySelector selectedDay={sel} onSelect={di => { setSel(di); setCardKey(k => k + 1); }} isMobile={isMobile} renderBadge={di => {
        const dx = dd[di];
        if (!dx.isOpen) return <span style={{ fontSize: 10, color: di === sel ? "rgba(255,255,255,0.5)" : "#CCC", fontFamily: "'DM Sans',sans-serif", textDecoration: "line-through" }}>Off</span>;
        return <span style={{ fontSize: 10, fontWeight: 600, color: di === sel ? "rgba(255,255,255,0.55)" : "#BBB", fontFamily: "'DM Sans',sans-serif" }}>{formatTime12(dx.open).replace(/:00/g, "").replace(" ", "")}</span>;
      }} />

      <div key={cardKey} style={{ marginTop: 12, animation: "fadeSlide 0.25s ease-out" }}>
        <div style={{ background: "#FFF", borderRadius: 16, padding: isMobile ? "16px" : "22px 28px", border: "1px solid #EBEBEB", boxShadow: "0 1px 4px rgba(0,0,0,0.03)" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: d.isOpen ? 20 : 0, paddingBottom: d.isOpen ? 16 : 0, borderBottom: d.isOpen ? "1px solid #F3F3F3" : "none" }}>
            <div style={{ fontSize: 16, fontWeight: 600, color: "#1a1a1a", fontFamily: "'DM Sans',sans-serif" }}>Restaurant Hours</div>
            <button onClick={() => setField(sel, "isOpen", !d.isOpen)} style={{ width: 44, height: 26, borderRadius: 13, border: "none", background: d.isOpen ? "#2D8F5E" : "#DDD", cursor: "pointer", position: "relative", WebkitTapHighlightColor: "transparent" }}>
              <div style={{ width: 20, height: 20, borderRadius: "50%", background: "#FFF", position: "absolute", top: 3, left: d.isOpen ? 21 : 3, transition: "left 0.2s cubic-bezier(0.4,0,0.2,1)", boxShadow: "0 1px 3px rgba(0,0,0,0.15)" }} />
            </button>
          </div>
          {d.isOpen && <>
            <div style={{ display: "flex", gap: 12, marginBottom: 20 }}>
              <TimeSelect value={d.open} onChange={v => setField(sel, "open", v)} isMobile={isMobile} label="Opens at" />
              <TimeSelect value={d.close} onChange={v => setField(sel, "close", v)} isMobile={isMobile} label="Closes at" />
            </div>
            <div style={{ fontSize: 13, fontWeight: 600, color: "#1a1a1a", fontFamily: "'DM Sans',sans-serif", marginBottom: 10 }}>Meal Periods</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {Object.keys(d.periods).map(pn => (
                <PeriodToggle key={pn} name={pn} active={d.periods[pn].active} start={d.periods[pn].start} end={d.periods[pn].end}
                  onToggle={() => setPeriod(sel, pn, "active", !d.periods[pn].active)}
                  onStart={v => setPeriod(sel, pn, "start", v)}
                  onEnd={v => setPeriod(sel, pn, "end", v)}
                  isMobile={isMobile} />
              ))}
            </div>
          </>}
        </div>
      </div>
    </div>
  );
}
